import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetUserMetadataParameters extends NextApiParams {}

export const getUserMetadata = withNextApi<
  GetUserMetadataResponse,
  GetUserMetadataParameters
>("/metadata/GetUserMetadata", { method: "GET" });

export interface GetUserMetadataResponse extends BackendResponse {
  item: UserMetadata;
}

export interface UserMetadata {
  lastSeenInPwa: string;
  /**
   * Raw column value: "{sessionId};{id1},{id2},{id3}" (new format) or "{id1},{id2},{id3}" (old format).
   * Use {@link parseLastConcernIdsCsv} to extract the ids and {@link parseLastConcernIdsSessionId}
   * to extract the session the ids belong to.
   */
  lastConcernIds?: string | null;
  /** The session ID from the current auth cookie — set by the server, not stored in the DB. */
  currentSessionId?: string | null;
  /** Optional JSON for other preferences (not used for last concerns). */
  settings?: string | null;
}

/** Parses {@link UserMetadata.lastConcernIds} into integers (strips session prefix if present). */
export function parseLastConcernIdsCsv(
  csv: string | null | undefined
): number[] {
  if (!csv || !csv.trim()) return [];
  const ids = stripSessionPrefix(csv);
  return ids
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => parseInt(s, 10))
    .filter((n) => Number.isFinite(n));
}

/** Extracts the session ID from {@link UserMetadata.lastConcernIds}, or null for old-format values. */
export function parseLastConcernIdsSessionId(
  csv: string | null | undefined
): string | null {
  if (!csv?.trim()) return null;
  const idx = csv.indexOf(";");
  return idx >= 0 ? csv.slice(0, idx) : null;
}

function stripSessionPrefix(csv: string): string {
  const idx = csv.indexOf(";");
  return idx >= 0 ? csv.slice(idx + 1) : csv;
}
